import lodash from 'lodash'

import { buildEmail, getUserEmails } from './util'
import { buildMetaData, buildExtendMetaDate, getLink } from './wpHelper'
import { PermTypeMapKeys } from '@/utils/aclHelper'
import { SEND_EMAIL } from './consts'
import { tenantProjectRouteNames, projectRouteNames, standaloneWpRouteNames } from '@/utils/consts'
import { WORK_PERMIT_TYPES } from '@/modules/workPermits/consts'
import dateUtil from '@/utils/dateUtil'
import workPermitsToContractor from './wpToContractor'

function getNextReviewerEmail (permit) {
  const managerEmail = lodash.get(permit, 'manager.contacts', []).find(contact => contact.type === 'EMAIL')
  return managerEmail ? managerEmail.value : ''
}

async function addLink (permit, metaData) {
  let routeName = ''
  if (permit.standalone) {
    routeName = standaloneWpRouteNames.engineerStandaloneWp
  } else {
    routeName = permit.isTenantProject ? tenantProjectRouteNames.tenantProject : projectRouteNames.projectDetail
  }
  metaData.link = await getLink(permit, routeName)
}

async function firstApplyWP (permit, type) {
  let emails = []
  let { metaData, building, tenancy } = await buildMetaData(permit)
  let permTypeKey
  if (permit.type === WORK_PERMIT_TYPES.PROJECT) {
    permTypeKey = PermTypeMapKeys.TMWORKPERMIT_REVIEW_1ST
  }
  if (permit.type === WORK_PERMIT_TYPES.WORK) {
    permTypeKey = PermTypeMapKeys.WORKPERMIT_REVIEW
  }
  const emailTo = await getUserEmails(building.id, tenancy.type, permTypeKey)
  await addLink(permit, metaData)

  buildEmail(emails, emailTo, type, metaData, SEND_EMAIL)
  return emails
}

async function nextReviewer (permit, type) {
  let emails = []
  let { metaData } = await buildMetaData(permit)

  const emailTo = getNextReviewerEmail(permit)
  await addLink(permit, metaData)
  buildEmail(emails, emailTo, type, metaData, SEND_EMAIL)
  return emails
}

async function hoistingNextReviewer (permit, type) {
  let emails = []
  let { metaData } = await buildMetaData(permit)
  const emailTo = getNextReviewerEmail(permit)
  await addLink(permit, metaData)
  buildEmail(emails, emailTo, type, metaData, SEND_EMAIL)
  return emails
}

async function applyExtendWPToHkLandUser (permit, type) {
  let emails = []
  let { metaData, building, tenancy } = await buildMetaData(permit)
  const emailTo = await getUserEmails(building.id, tenancy.type, PermTypeMapKeys.TMWORKPERMIT_REVIEW_1ST)
  metaData.link = await getLink(permit, tenantProjectRouteNames.tenantProject)
  metaData = buildExtendMetaDate(permit, metaData)
  buildEmail(emails, emailTo, type, metaData, SEND_EMAIL)
  return emails
}

async function applyHoisting (permit, type) {
  let emails = []
  let { metaData, building, tenancy } = await buildMetaData(permit)
  const userPermission = dateUtil.isWithinOfficeHours(permit.startDate, permit.endDate)
    ? PermTypeMapKeys.APPROVE_OFFICE_HOURS_HOISTING
    : PermTypeMapKeys.REVIEW_AFTER_OFFICE_HOURS_HOISTING
  const emailTo = await getUserEmails(building.id, tenancy.type, userPermission)
  await addLink(permit, metaData)
  buildEmail(emails, emailTo, type, metaData, SEND_EMAIL)
  return emails
}

async function applyHoistingAfterOfficeHour (permit, type) {
  let emails = []
  let { metaData, building, tenancy } = await buildMetaData(permit)
  const emailTo = await getUserEmails(building.id, tenancy.type, PermTypeMapKeys.REVIEW_AFTER_OFFICE_HOURS_HOISTING)
  await addLink(permit, metaData)
  buildEmail(emails, emailTo, type, metaData, SEND_EMAIL)
  return emails
}

async function hoistingWAPPR (permit, type) {
  let emails = []
  let { metaData, building, tenancy } = await buildMetaData(permit)
  const emailTo = await getUserEmails(building.id, tenancy.type, PermTypeMapKeys.APPROVE_OFFICE_HOURS_HOISTING)
  await addLink(permit, metaData)
  buildEmail(emails, emailTo, type, metaData, SEND_EMAIL)
  return emails
}

async function hoistingAfterOfficeHourWAPPR (permit, type) {
  let emails = []
  let { metaData, building, tenancy } = await buildMetaData(permit)
  const emailTo = await getUserEmails(building.id, tenancy.type, PermTypeMapKeys.REVIEW_AFTER_OFFICE_HOURS_HOISTING)
  await addLink(permit, metaData)
  buildEmail(emails, emailTo, type, metaData, SEND_EMAIL)
  return emails
}

const workPermitsNotification = {
  firstApplyWP,
  applyHoisting,
  applyHoistingAfterOfficeHour,
  hoistingWAPPR,
  hoistingAfterOfficeHourWAPPR,
  nextReviewer,

  hoistingNextReviewer,
  applyExtendWPToHkLandUser,
  ...workPermitsToContractor,
}

export default workPermitsNotification
